import { combineLatest, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';

export const combineLatestBatch: typeof combineLatest = function () {
  // eslint-disable-next-line prefer-spread
  return combineLatest.apply(null, arguments).pipe(switchMap(v => from(Promise.resolve(v))));
};
